export default __webpack_public_path__ + "static/media/email.205a7bef.svg";